import {appUrls} from "../helpers/Urls";
import axiosInstance from "../utils/axiosInstance";

const getPatientInfo = async (patientId)=>{
    const {data} = await axiosInstance.get(appUrls.getPatientInfo(patientId));
    return data
}
export default getPatientInfo